import axios from 'axios';

import { HIERARCHY } from '../endpoints';
import { Pool } from 'components/types';
import {
  Cluster,
  EmpPool
} from 'components/admin-portal/Tables/Settings/PlanUnits/types';

export interface HierarchyValue {
  code: string;
  sortOrder: string;
  colorCode: `#${string}` | undefined;
  flags: string[];
  parentBrDynId?: number;
  brId: number;
  brDynId: number;
  category: string;
  clusters: Cluster[];
  employerId: string;
  employerName: string;
  hierarchy: string[];
  name: string;
  nameShort: string;
  type: string;
  typeName: string;
  validFrom: object;
  visibleUntil: string;
  pool?: Pool;
  poolName?: string;
  empPool?: EmpPool;
  descendants?: string[];
}

export const getHierarchyValues = (startDate: string, endDate: string) =>
  axios.get<HierarchyValue[]>(
    `${HIERARCHY}?startDate=${startDate}&endDate=${endDate}`
  );
